import React from 'react';
import { motion } from 'motion/react';
import { Users, Briefcase, BookOpen, FileCheck, Clock, Layers } from 'lucide-react';

const milestones = [
  { label: "Language and subject experts all over India", value: "3500+", icon: <Users size={24} /> },
  { label: "In-house technical + language experts", value: "206", icon: <Users size={24} /> },
  { label: "Unique Customers", value: "136+", icon: <Briefcase size={24} /> },
  { label: "Pages Translated", value: "150+ cr", icon: <FileCheck size={24} /> },
  { label: "Video Translation", value: "2000+ hrs", icon: <Clock size={24} /> },
  { label: "Unique Tools/Services", value: "76+", icon: <Layers size={24} /> }
];

export const Milestones = () => {
  return (
    <section className="py-24 bg-indigo-900 relative overflow-hidden">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/10 blur-3xl rounded-full" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/10 blur-3xl rounded-full" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">Milestones at a Glance</h2>
          <p className="text-indigo-200 ">Driving excellence across India and beyond.</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-6 gap-6">
          {milestones.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white/10 backdrop-blur-lg border border-white/10 p-6 rounded-2xl text-center hover:bg-white/20 transition-all cursor-default group"
            >
              <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center mx-auto mb-4 text-white group-hover:scale-110 transition-transform">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-white mb-2">{stat.value}</div>
              <div className="text-xs font-medium text-indigo-100 uppercase tracking-wider">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
